// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3O7Si","buttons":"SendReceipts_buttons__13dst","email":"SendReceipts_email__bXOT8","bookApptTitle":"SendReceipts_bookApptTitle__33I8E"};